<!-- <div class="container-fluid">
<div class="row">
    <div class="col-10">
        <nav class="navbar navbar-expand-lg ">
            <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </nav>
    </div>
    <span class = "helplogout">
        <div class="col-2">
          <a class="space">Need&nbsp;Help</a>

      </div>
      </span>
</div>
</div> -->

<div class="container-fluid px-lg-5">
  <div class="row">
    <div class="col-12">
      <nav class="navbar navbar-expand-sm">
        <a class="navbar-brand" (click)="OnLogoClick()">
          <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </a>

        <ul class="nav ml-auto">
          <li><a class="pl-4" (click)="OnLogoClick()">Need&nbsp;Help</a></li>


        </ul>

      </nav>
    </div>
  </div>
</div>

<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link paddingFromApp" routerLink="/landing">Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/started">Getting Started</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/resources">Resources</a>
            </li>

        </ul>
    </div>
</nav> -->


<section class="login-block">
  <div class="container">
    <div class="row">

      <div class="col-lg-8 login-sec">

        <form class="login-form">













          <br>

          <h2 class="mb-0 text-center">Login Now</h2>

          <div class="form-group">
            <label for="userName" class="cols-sm-2 control-label required">UserName</label>
            <div class="cols-sm-10">
              <div class="input-group">
                <span class="input-group-addon"></span>
                <input type="text" class="form-control" name="UserName" id="userName" placeholder="Enter UserName "
                  [(ngModel)]="UserName" #userName=ngModel required />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="Password" class="cols-sm-2 control-label required">Password</label>
            <div class="cols-sm-10">
              <div class="input-group">
                <span class="input-group-addon"></span>
                <input type="Password" class="form-control" name="Password" id="Password" placeholder="Enter Password "
                  [(ngModel)]="Password" #password=ngModel required />
              </div>
            </div>
          </div>
          <p *ngIf="errorMsg">UserName or Password is not correct. Please try it again.</p>
          <p *ngIf="!password.valid && userName.valid">Password should be filled.</p>
          <p *ngIf="!userName.valid && password.valid">UserName should be filled.</p>
          <p *ngIf="!userName.valid && !password.valid">UserName and Password should be filled.</p>


          <div class="inner">

            <div class="inner">

              <a class="nav-link fgtpwd" style="
                            padding-top: 0px;
                            padding-left: 0px; color: #4E33D1" (click)="onForgetPassword()">Forgot Password </a>

              <!-- <button type="button"  class="btn  btn-primary btn-password" (click)="onForgetPassword()"> ForGot Password

              </button> -->


            </div>

            <button type="button" style="
                        margin-right: 20px; margin-left: 0px;" class="btn  btn-primary btn-login"
              (click)="onVerifyLoginCredentials()">
              Login
            </button>


          </div>
          <div class="inner">
            <button type="button" class="btn  btn-primary btn-register" routerLink="/signup">Register</button>


          </div>



        </form>

      </div>
    </div>
    <!-- <div class="col-md-8 banner-sec">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner" role="listbox">

                <div class="carousel-item active">

                    <img class="d-block img-fluid" src="https://static.pexels.com/photos/33972/pexels-photo.jpg"
                        alt="First slide">
                    <div class="carousel-caption d-none d-md-block">
                        <div class="banner-text">
                            <h2>This is Home </h2>
                            <p>This Developer Portal for third-party App Registration and Management.</p>
                        </div>

                    </div>
                </div>


                <div class="carousel-item">

                    <img class="d-block img-fluid"
                        src="https://images.pexels.com/photos/7097/people-coffee-tea-meeting.jpg"
                        alt="First slide">
                    <div class="carousel-caption d-none d-md-block">
                        <div class="banner-text">
                            <h2><a class="anchor-color ">Getting Started With All Doumentation</a>
                            </h2>
                            <p>This Developer Portal for third-party App Registration and Management</p>
                        </div>
                    </div>

                </div>

                <div class="carousel-item">
                    <img class="d-block img-fluid"
                        src="https://images.pexels.com/photos/872957/pexels-photo-872957.jpeg"
                        alt="First slide">
                    <div class="carousel-caption d-none d-md-block">
                        <div class="banner-text">
                            <h2>Services</h2>
                            <p>This Developer Portal for third-party App Registration and Management.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div> -->

  </div>

</section>
<div>
  <app-footer></app-footer>
</div>